export default "__VITE_ASSET__tJxvHmTi__"